export const GET_POLLS_REQUEST = 'GET_POLLS_REQUEST';
export const GET_POLLS_SUCCESS = 'GET_POLLS_SUCCESS';
export const GET_POLLS_FAILURE = 'GET_POLLS_FAILURE';

export const DELETE_POLL_REQUEST = 'DELETE_POLL_REQUEST'
export const DELETE_POLL_SUCCESS = 'DELETE_POLL_SUCCESS'
export const DELETE_POLL_FAILURE = 'DELETE_POLL_FAILURE'
export const EDIT_POLL_REQUEST = 'EDIT_POLL_REQUEST'
export const EDIT_POLL_SUCCESS = 'EDIT_POLL_SUCCESS'
export const EDIT_POLL_FAILURE = 'EDIT_POLL_FAILURE'
export const EDIT_POLL_PASSCODE_REQUEST = 'EDIT_POLL_PASSCODE_REQUEST'
export const EDIT_POLL_PASSCODE_SUCCESS = 'EDIT_POLL_PASSCODE_SUCCESS'
export const EDIT_POLL_PASSCODE_FAILURE = 'EDIT_POLL_PASSCODE_FAILURE'
export const UPDATE_POLL = 'UPDATE_POLL'
export const FLUSH_OP_ERRORS = 'FLUSH_OP_ERRORS'
export const FLUSH_POLLS = 'FLUSH_POLLS'